import React from "react";
import { Link, useLocation } from "react-router-dom";
import tools from "../../images/tools.svg";
import home from "../../images/home.svg";
import split from "../../images/split.svg";
import messages from "../../images/messages.svg";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";

import mysplit from "../../images/mysplit.png";
import shop from "../../images/shop.png";
import shoe from "../../images/shoe.png";
import homeIcon from "../../images/homeIcon.png";

import shopActive from "../../images/shopActive.png";
import mysplitActive from "../../images/mysplitActive.png";
import shoeActive from "../../images/shoeActive.png";
import homeIconActive from "../../images/homeIconActive.png";

export const AthleteFooter = () => {
  const location = useLocation();
  const { athlete } = useAthleteAuthContext();

  // Determine correct Coaching route based on account type
  const coachingRoute =
    athlete.account_type === "AMAX COACHED"
      ? "/athlete/coached/warmup-routine-phases"
      : "/athlete/free-warmup-routine/phase";

  // Override the navLinks array with dynamic coaching route
  // const navLinks = [
  //   { to: "/athlete/dashboard", icon: home, label: "Home" },
  //   { to: coachingRoute, icon: tools, label: "Workouts" },
  //   { to: "/athlete/mysplit", icon: split, label: "MySplit" },
  //   { to: "/athlete/tools", icon: tools, label: "Shop" },
  // ];
  const navLinks = [
    {
      to: "/athlete/dashboard",
      icon: homeIcon,
      activeIcon: homeIconActive,
      label: "Home",
    },
    {
      to: coachingRoute,
      icon: shoe,
      activeIcon: shoeActive,
      label: "Workouts",
    },
    {
      to: "/athlete/mysplit",
      icon: mysplit,
      activeIcon: mysplitActive,
      label: "MySplit",
    },
    { to: "/athlete/tools", icon: shop, activeIcon: shopActive, label: "Shop" },
  ];

  // Highlight coaching for all COACHED inner pages
  const isCoachingActive =
    // AMAX COACHED routes
    (athlete.account_type === "AMAX COACHED" &&
      (location.pathname.startsWith("/athlete/coached/warmup-routine-phases") ||
        location.pathname.startsWith(
          "/athlete/coached/warmup-routine-phase-exercises"
        ) ||
        location.pathname.startsWith("/athlete/coached/speed-workout") ||
        location.pathname.startsWith("/athlete/coached/strength-workout"))) ||
    // NON-AMAX COACHED routes
    (athlete.account_type !== "AMAX COACHED" &&
      (location.pathname.startsWith("/athlete/free-warmup-routine/phase") ||
        location.pathname.startsWith("/athlete/free-speed-workout") ||
        location.pathname.startsWith("/athlete/free-strength-workout")));

  return (


    <div className="px-5 py-3">
      <div className="bg-smock w-full max-w-2xl mx-auto flex justify-between items-stretch rounded-[46px]">
        {navLinks.map(({ to, activeIcon, icon, label }) => {
          const isActive =
            label === "Workouts"
              ? isCoachingActive || location.pathname === coachingRoute
              : location.pathname === to;

          return (
            <Link
              key={to}
              to={to}
              className="flex flex-col justify-center items-center group rounded-[48px] p-3 flex-1 hover:bg-black group"
              style={{ backgroundColor: isActive ? "#000" : "" }}
            >
              <img
                src={isActive ? activeIcon : icon}
                alt={label}
                className="object-contain w-full max-w-6 xs:max-w-9"
                // style={{ opacity: isActive ? 1 : 0.4 }}
              />
              {/* <span
              className={`text-[11px] tracking-[0.66px] capitalize font-bold ${
                isActive ? "opacity-100 text-black" : "opacity-40 text-black"
              } group-hover:opacity-90 transition-all`}
            >
              {label}
            </span> */}
            </Link>
          );
        })}
      </div>
    </div>
  );
};
